import { render } from "./TestReports.vue?vue&type=template&id=e699fe92"
import script from "./TestReports.vue?vue&type=script&lang=js"
export * from "./TestReports.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/cases/TestReports.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e699fe92"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e699fe92', __exports__)) {
    console.log('reload')
    api.reload('e699fe92', __exports__)
  }
  
  module.hot.accept("./TestReports.vue?vue&type=template&id=e699fe92", () => {
    console.log('re-render')
    api.rerender('e699fe92', render)
  })

}


export default __exports__